import { render, staticRenderFns } from "./Align.vue?vue&type=template&id=bb5f6060&functional=true"
import script from "./Align.vue?vue&type=script&lang=js"
export * from "./Align.vue?vue&type=script&lang=js"
import style0 from "./Align.vue?vue&type=style&index=0&id=bb5f6060&lang=scss&module=true"

var cssModules = {}
var disposed = false

function injectStyles (context) {
  if (disposed) return
  
        cssModules["$style"] = (style0.locals || style0)
        Object.defineProperty(this, "$style", {
          configurable: true,
          get: function () {
            return cssModules["$style"]
          }
        })
      
}


  module.hot && module.hot.dispose(function (data) {
    disposed = true
  })



        module.hot && module.hot.accept(["./Align.vue?vue&type=style&index=0&id=bb5f6060&lang=scss&module=true"], function () {
          var oldLocals = cssModules["$style"]
          if (oldLocals) {
            var newLocals = require("./Align.vue?vue&type=style&index=0&id=bb5f6060&lang=scss&module=true")
            if (JSON.stringify(newLocals) !== JSON.stringify(oldLocals)) {
              cssModules["$style"] = newLocals
              require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js").rerender("bb5f6060")
            }
          }
        })

/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  injectStyles,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/drone/src/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bb5f6060')) {
      api.createRecord('bb5f6060', component.options)
    } else {
      api.rerender('bb5f6060', component.options)
    }
    module.hot.accept("./Align.vue?vue&type=template&id=bb5f6060&functional=true", function () {
      api.rerender('bb5f6060', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/layout/Align.vue"
export default component.exports